import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { CoursesDTO } from "../Courses/GetAllCourses";
export type OfflineCourseByIdDTO = CoursesDTO & {
  isTrending: boolean;
  googleForm: string;
  isAvailable: boolean;
  chapters: {
    id: string;
    description: string | null;
    name: string | null;
    _count: {
      lectures: number;
    };
    lectures: {
      id: string;
      title: string;
      videos: string[];
      _count: {
        resources: number;
      };
      order: number;
    }[];
    order: number;
  }[];
};
type getCourseResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: OfflineCourseByIdDTO;
};
export const GetOfflineCourseById = async (
  courseId: string
): Promise<getCourseResponse> => {
  try {
    const response = await axios.get(`/offline-course/${courseId}`);
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
